import { render, staticRenderFns } from "./LayoutHeader.vue?vue&type=template&id=bafa59f2&"
import script from "./LayoutHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafa59f2')) {
      api.createRecord('bafa59f2', component.options)
    } else {
      api.reload('bafa59f2', component.options)
    }
    module.hot.accept("./LayoutHeader.vue?vue&type=template&id=bafa59f2&", function () {
      api.rerender('bafa59f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutHeader.vue"
export default component.exports